/**
 * Keyboard keyCodes
 */
export const keyCodes = { // eslint-disable-line import/prefer-default-export
  escape: 27,
  tab: 9,
  enter: 13,
};



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/shared/constants/keyboard.js